import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface ICardTextProps extends TestingProps {
  children?: React.ReactNode;
  muted?: boolean;
  small?: boolean;
  className?: string;
}

export const CardText: React.FunctionComponent<ICardTextProps> = (props) => {
  return (
    <p
      className={C(
        'card-text',
        props.muted && 'text-muted',
        props.small && 'small',
        props.className
      )}
      data-testid={props.testId}
    >
      {props.children}
    </p>
  );
};
